<div>
    <hub-modal-header headerText="{{ 'general.update_available' | translate }}" 
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">
    <div class="row">
        <div class="col-lg-12">
            <div class="update-message">
                <div class="update-text">
                    <p>{{ 'general.new_version_description' | translate }}</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer-container">
    <div class="button-container">
        <hub-button [text]="'general.refresh_now' | translate"
            [style]="'primary'" 
            [size]="'xl'"
            (buttonClick)="refreshPage()"></hub-button>
        <hub-button [text]="'general.later' | translate"
            [style]="'outline'" 
            [size]="'xl'"
            (buttonClick)="dismissModal()"></hub-button>
    </div>
</div>
